<div class="row">
  <div class="col-lg-3">
    <sb-card>
      <div card-body>
        <ul class="nav-tabs nav sidenav">
          <li class="nav-item">
            <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.productDetailsOverview"
               [sbRouterLink]="util.RoutingID.productDetailsOverview"><span><sb-icon class="mr-3" icon="eye"></sb-icon>
              {{ 'lang.globals.overview' | translate }}</span></a>
          </li>
          <li class="nav-item" *ngPermissions="[permissionService.Permission.product_attribute_datatype_list]">
            <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.productDetailsAttributes"
               [sbRouterLink]="util.RoutingID.productDetailsAttributes"><span><sb-icon class="mr-3" icon="attributes"></sb-icon>
              {{ 'lang.globals.attributes' | translate }}</span></a>
          </li>
          <li class="nav-item" *ngPermissions="[permissionService.Permission.product_category_list]">
            <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.productDetailsCategories"
               [sbRouterLink]="util.RoutingID.productDetailsCategories"><span><sb-icon class="mr-3" icon="productCategory"></sb-icon>
              {{ 'lang.globals.categories' | translate }}</span></a>
          </li>
        </ul>
      </div>
    </sb-card>
  </div>
  <div class="col-lg-9">
    <router-outlet></router-outlet>
  </div>
</div>
